import { createStyles } from '@material-ui/core';

export const SCROLL_BAR_WIDTH = 15;
const BUTTON_SIZE = 35;

export const styles = () =>
    createStyles({
        documentCover: {
            boxSizing: 'border-box',
            backgroundColor: '#616971',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            padding: '10px 35px 0 35px',
            height: '100%'
        },

        documentHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: '10px 0',
            alignItems: 'center'
        },

        documentTitle: {
            color: 'white',
            fontWeight: 'bolder',
            paddingLeft: '20px'
        },

        viewerButtonsContainer: {
            userSelect: 'none'
        },

        buttonIcon: {
            width: 23,
            height: 24
        },

        buttonStyle: {
            color: '#206c92',
            backgroundColor: '#ffffff',
            minWidth: BUTTON_SIZE,
            minHeight: BUTTON_SIZE,
            width: BUTTON_SIZE,
            height: BUTTON_SIZE,
            padding: 0,
            '&:disabled': {
                backgroundColor: 'rgba(255,255,255,.6)',
                color: 'rgba(32,108,146,.6)',
                '&:hover': {
                    backgroundColor: 'rgba(255,255,255,.6)',
                    color: 'rgba(32,108,146,.6)'
                }
            },
            '&:hover': {
                backgroundColor: '#ddeaef',
                color: '#206c92'
            },
            '&:active': {
                backgroundColor: '#bfd7e1',
                color: '#206c92'
            }
        },

        buttonLaunch: {
            borderRadius: '0px 4px 4px 0px'
        },

        buttonDisabled: {
            color: 'rgba(32,108,146,.6)'
        },

        documentInternals: {
            overflowX: 'hidden',
            overflowY: 'scroll',
            width: `calc(100% + ${SCROLL_BAR_WIDTH}px)`,
            '&::-webkit-scrollbar': {
                width: 7
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'rgba(255,255,255,.3)',
                borderRadius: 5
            }
        },

        documentContainer: {
            position: 'static',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            boxSizing: 'border-box',
            userDrag: 'none',
            userSelect: 'none'
        },

        documentImg: {
            margin: '0 0 10px 0',
            boxSizing: 'border-box',
            userDrag: 'none',
            userSelect: 'none',
            pointerEvents: 'none',
            maxWidth: '100%',
            height: 'auto'
        }
    });
